import { shopifyCartApi } from "@/services/shopifyCart";
import React, { useEffect } from "react";
import { useCartUiActions, useCartDrawerIsOpen } from "./cartStore";
import { CartDrawer } from "./CartDrawer";
import { OverviewPage } from "./CartDrawer/pages/OverviewPage";
import { storefrontApi } from "@/services/storefront";
import { DroppsCatalog } from "@/store";

const Cart = () => {
  const { closeDrawer } = useCartUiActions();
  const isOpen = useCartDrawerIsOpen();
  const allProducts: DroppsCatalog | undefined =
    storefrontApi.useAllProducts().data;

  const cartUiActions = useCartUiActions();

  useEffect(() => {
    // @ts-ignore
    window.cartUi = cartUiActions;
  }, [cartUiActions]);

  const shopifyCart = shopifyCartApi.useFetch();

  useEffect(() => {
    const cartButton = document.getElementById("btn-open-cart");

    if (!cartButton) return;

    const total =
      shopifyCart.data?.items.reduce((sum, i) => sum + i.quantity, 0) ?? 0;
    const emptyIcon = cartButton.querySelector("#nav-cart-icon-empty");
    const filledIcon = cartButton.querySelector("#nav-cart-icon-filled");

    if (emptyIcon && filledIcon) {
      if (total > 0) {
        emptyIcon.classList.add("hidden");
        filledIcon.classList.remove("hidden");
      } else {
        emptyIcon.classList.remove("hidden");
        filledIcon.classList.add("hidden");
      }
    }

    // Update count if it exists
    const countEl = cartButton.querySelector("#nav-cart-count");

    if (countEl) {
      countEl.textContent =
        total > 99 ? "99+" : total > 0 ? total.toString() : "";
    }

    // Update data attribute
    cartButton.setAttribute("data-cart-count", total.toString());
  }, [shopifyCart.data]);

  return (
    <CartDrawer
      open={isOpen}
      onExit={closeDrawer}
      goToFirstPage={() => {}}
      title="Your cart"
      contents={() => (
        <OverviewPage
          onExit={closeDrawer}
          allProducts={allProducts?.all}
          goToFirstPage={() => {}}
        />
      )}
    />
  );
};

export default Cart;
